import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'

export function download(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/inquiry-proof-copies/${id}/file`,
        headers: {},
    }
}

export function upload(
    manufacturerId: number,
    inquiryNumber: number,
    blob: Blob,
): HttpRequest {
    const form = new FormData()
    form.append('proofCopy', blob)
    return {
        verb: 'POST',
        url: `${server}/manufacturers/${manufacturerId}/inquiries/${inquiryNumber}/proof-copies`,
        headers: {Accept: 'application/json'},
        body: form,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/InquiryProofCopyResource.ts